import { Link } from "react-router-dom";
import { input, label } from "./ui";

const field = (id, title, props) => ({ id, title, props });
const FIELDS = [
    field("name", "Nome completo do responsável", { required: true, minLength: 3, maxLength: 120, autoComplete: "name" }),
    field("phone", "WhatsApp com DDD", { required: true, inputMode: "tel", placeholder: "(12) 99999-9999", pattern: "[0-9()+\\-\\s]{10,20}", autoComplete: "tel" }),
    field("email", "E-mail", { required: true, type: "email", maxLength: 160, autoComplete: "email" }),
    field("birthdate", "Data de nascimento", { required: true, type: "date", autoComplete: "bday" }),
];

export function CustomerForm({ value, onChange }) {
    const set = (k) => (e) => onChange({ ...value, [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value });
    return (
        <div className="space-y-4" data-testid="customer-form">
            <div className="grid gap-4 sm:grid-cols-2">
                {FIELDS.map((f) => (
                    <div key={f.id}>
                        <label htmlFor={`booking-${f.id}`} className={label}>{f.title}</label>
                        <input id={`booking-${f.id}`} data-testid={`booking-${f.id}`} className={input} value={value[f.id]} onChange={set(f.id)} {...f.props} />
                    </div>
                ))}
            </div>
            <div>
                <label htmlFor="booking-notes" className={label}>Observações (opcional)</label>
                <textarea id="booking-notes" data-testid="booking-notes" maxLength={1000} rows={3} className={input} value={value.notes} onChange={set("notes")} />
            </div>
            <label className="flex gap-3 text-sm text-dim">
                <input type="checkbox" data-testid="booking-consent" checked={value.consent} onChange={set("consent")} required />
                <span>Sou maior de idade, li a <Link to="/privacidade" className="text-neon-cyan underline">política de privacidade</Link> e a <Link to="/politica-de-cancelamento" className="text-neon-cyan underline">política de cancelamento</Link>, e entendo que a reserva depende da confirmação da equipe.</span>
            </label>
        </div>
    );
}
